import { render } from "./PaywallManage.vue?vue&type=template&id=35dc9de2"
import script from "./PaywallManage.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallManage.vue?vue&type=script&setup=true&lang=js"

import "./PaywallManage.vue?vue&type=style&index=0&id=35dc9de2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/PaywallDash/PaywallManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35dc9de2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35dc9de2', __exports__)) {
    api.reload('35dc9de2', __exports__)
  }
  
  module.hot.accept("./PaywallManage.vue?vue&type=template&id=35dc9de2", () => {
    api.rerender('35dc9de2', render)
  })

}


export default __exports__